import {IsInt, IsEmail, IsString, IsDateString, IsNumber, IsDate,IsAlphanumeric, MaxLength, Matches, IsOptional, IsNotEmpty, ValidateNested, IsEnum } from 'class-validator';
import { ApiProperty } from '@nestjs/swagger';
import { FarmsInfo } from './farms.model';
import { FarmersModel } from './farmers.model';
import { SupplierTypeEnum } from '@gtpl/shared-models/common-models';
export class SuppliersDTO {
  @ApiProperty()
  // @MaxLength(7, { message: "States id allows maximum 7 characters" })
  //  @Matches(new RegExp("^[a-zA-Z0-9]+$"), '', { message: "States Code should not include these Charecters !@#$%^&*()_+{}[]:\";'<>?,./~` " })
  @IsNotEmpty({message:"Supplier id should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  supplierId?: number;
  @ApiProperty()
  @IsNotEmpty({message:"SupplierrCode should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  supplierCode: string;
  @ApiProperty()
  @MaxLength(15, { message: "vendorName allows maximum 15 characters" })
  @IsNotEmpty()
  @Matches(new RegExp("^[a-zA-Z0-9\\s]+$"),{ message:"Supplier name should be only alpha numeric" })
  // @IsNotBlank('StatesName', { message: "States Name is not to be a white spaces" })
  supplierName: string;
  @ApiProperty()
  @IsOptional()
  gstNumber: string;

  @ApiProperty()
  @IsOptional()
  state: string;

  @ApiProperty()
  @IsOptional()
  district: string;

  @ApiProperty()
  @IsOptional()
  commission: number;

  @ApiProperty({enum:Object.values(SupplierTypeEnum)})
  @IsNotEmpty()
  @IsEnum(SupplierTypeEnum)
  supplierCategory: SupplierTypeEnum;


  @ApiProperty()
  @IsOptional()
  brokerId: number;
  
  @ApiProperty()
  @IsNotEmpty({message:"contactPerson should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  contactPerson: string;
  @ApiProperty()
  @IsNotEmpty({message:"street should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  street: string;
  @ApiProperty()
  @IsNotEmpty({message:"appartment should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  apartment: string;
  @ApiProperty()
  @IsNotEmpty({message:"city should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  city: string;
  @ApiProperty()
  @IsNotEmpty({message:"postalCode should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  postalCode: string;
 
 
  @ApiProperty()
  @IsNotEmpty({message:"bankAccNo should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  bankAccNo: string;
  @ApiProperty()
  @IsNotEmpty({message:"bankIfsc should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  bankIfsc: string;
  @ApiProperty()
  @IsNotEmpty({message:"bankName should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  bankName: string;
  @ApiProperty()
  @IsNotEmpty({message:"bankBranch should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  bankBranch: string;
  @ApiProperty()
  @IsNotEmpty({message:"ContactNumber should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  contactNumber: string;
  @ApiProperty()
  @IsNotEmpty({message:"EmailId should not be empty"})
  @IsAlphanumeric()
  @IsOptional()
  emailId: string;
  @ApiProperty()
  isActive: boolean;
  @ApiProperty()
  @IsOptional()
  paymentPeriod:number
  createdAt : Date;

  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Created User allows maximum 40 characters" })
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "created user should be only numbers" })
  createdUser : string;

  updatedAt : Date;
  @ApiProperty()
  @IsOptional()
  @MaxLength(40, { message: "Updated User allows maximum 40 characters"})
  @Matches(new RegExp("^(?:[a-zA-Z\\s]|)+$"),{ message: "updated user should be only numbers" })
  updatedUser : string;

  @ApiProperty()
  versionFlag : number;

  @ApiProperty({ type: [FarmsInfo]})
  farmInfo: FarmsInfo[];

  @ApiProperty()
  Farmers?: number[];

}

